import React from "react";
import "./footer.style.css";
import Subscribe from "./Subscribe";

const Footer = () => {
  return (
    <footer
      className="footer"
      itemScope
      itemType="https://schema.org/WPFooter"
    >
      <Subscribe />

      <div
        style={{
          flex: 0.4,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "20px",
        }}
      >
        <h4>CATCH ME CANDID HERE</h4>

        <div
          className="social-media-links"
          itemScope
          itemType="https://schema.org/Person"
        >
          <meta itemProp="name" content="Swagat Vyas" />

          <a
            className="media-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.linkedin.com/in/swagat9?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
            itemProp="sameAs"
            aria-label="Swagat Vyas LinkedIn Profile"
          >
            <img
              src={require("./asset/linkedin.png")}
              alt="LinkedIn profile of Swagat Vyas"
              loading="lazy"
            />
          </a>

          <a
            className="media-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.facebook.com/share/P143npKfWjRfTU9w/?mibextid=LQQJ4d"
            itemProp="sameAs"
            aria-label="Swagat Vyas Facebook Profile"
          >
            <img
              src={require("./asset/facebook.png")}
              alt="Facebook profile of Swagat Vyas"
              loading="lazy"
            />
          </a>

          <a
            className="media-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.instagram.com/swagat9?igsh=MTZzeXNnMmNkdmxkbA=="
            itemProp="sameAs"
            aria-label="Swagat Vyas Instagram Profile"
          >
            <img
              src={require("./asset/instagram.png")}
              alt="Instagram profile of Swagat Vyas"
              loading="lazy"
            />
          </a>
        </div>
      </div>

      <p>© 2025 Swagat Vyas</p>
    </footer>
  );
};

export default Footer;
